import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { Routes, Route } from "react-router-dom"; // ✅ only import Routes/Route
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./App.css";
import Homepage from "./pages/Homepage";
import Footer from "./components/Footer";
import { ModalProvider } from "./components/ModalContext";
import SimpleLoginModal from "./components/SimpleLoginModal";
import { useModal } from "./components/ModalContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderTwo from "./components/HeaderTwo";
import ContactForm from "./components/ContactForm";
import ThankYouPage from "./pages/ThankYouPage"; // ✅ import Thank You page

function App() {
  return (
    <ModalProvider>
      <Routes>
        <Route path="/" element={<MainApp />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
      </Routes>
    </ModalProvider>
  );
}

function MainApp() {
  const [showForm, setShowForm] = useState(true);
  const { openModal } = useModal();

  return (
    <div>
      <SimpleLoginModal />
      <HeaderTwo />
      <Homepage />
      <Footer />

      {showForm && (
        <>
          {/* Desktop Form Section */}
          <div className="hidden xl:block fixed bottom-0 left-0 w-full bg-[#c55b12] backdrop-blur-md shadow-[0_-4px_10px_rgba(0,0,0,0.1)] z-[999]">
            <div className="relative 2xl:max-w-screen-xl mx-auto py-2 px-16 2xl:px-4 flex items-center gap-10">
              <div className="flex-shrink-0 text-white font-crimson text-[28px] tracking-wide">
                <p>Get a Call Back</p>
              </div>
              <div className="flex-1">
                <ContactForm variant="desktop" />
              </div>
            </div>
          </div>

          {/* Mobile Button */}
          <div className="flex xl:hidden fixed bottom-0 left-0 right-0 gap-3 z-[1000] bg-[#a64a10] p-5 font-inter">
            <button
              className="flex-1 py-3 text-[#000000d9] bg-[#f6f4ed] border-2 border-[#fff] rounded-2xl flex items-center justify-center"
              onClick={openModal}
            >
              Book Your Site Visit Today
            </button>
          </div>
          {/* Download Brochure */}
          <button
            onClick={openModal}
            className="fixed right-0 top-1/2 z-20 flex -translate-y-1/2 items-center gap-2 rounded-l-xl bg-[#d86a13] px-3 py-6 text-sm font-semibold text-white shadow-xl"
            style={{
              writingMode: "vertical-rl",
            }}
          >
            DOWNLOAD BROCHURE
          </button>
          {/* Close Icon */}
          <button
            onClick={() => setShowForm(false)}
            className="hidden xl:block fixed bottom-2 right-2 text-[#5e3920] hover:text-[#c55b12] z-[1000] bg-white rounded-full shadow-lg items-center justify-center w-10 h-10 mt-2"
            aria-label="Close form"
          >
            <CloseIcon style={{ fontSize: 24, fontWeight: "bold" }} />
          </button>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            className="z-50"
          />
        </>
      )}
    </div>
  );
}

export default App;
